import { createAction } from 'redux-actions';
import { createRoutine } from 'redux-saga-routines';
import {
  FINANCIAL_REPORT_GET_LABOR_EFFICIENCY,
  FINANCIAL_REPORT_SET_DATE_RANGE,
  FINANCIAL_REPORT_SET_STUDIOS,
} from './types';

export const financialReportSetDateRange = createAction(
  FINANCIAL_REPORT_SET_DATE_RANGE
);
export const financialReportSetStudios = createAction(
  FINANCIAL_REPORT_SET_STUDIOS
);
export const financialReportGetLaborEfficiency = createRoutine(
  FINANCIAL_REPORT_GET_LABOR_EFFICIENCY
);
